import * as React from 'react'
import type { SVGProps } from 'react'
function SvgMsKlimadashboardIconsNaviTeilen(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      color="currentColor"
      data-name="Ebene 1"
      viewBox="0 0 22.2 24.5"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M16.98 14.07c-2 0-3.72 1.14-4.6 2.8L9.74 15.1c.42-.75.69-1.61.69-2.53 0-.8-.19-1.54-.51-2.22l2.94-1.97c.95 1.24 2.44 2.06 4.12 2.06 2.88 0 5.22-2.34 5.22-5.22S19.86 0 16.98 0s-5.22 2.34-5.22 5.22c0 .47.08.92.2 1.35L8.73 8.73c-.93-.85-2.16-1.39-3.52-1.39-2.88 0-5.22 2.34-5.22 5.22s2.34 5.22 5.22 5.22c1.23 0 2.35-.45 3.24-1.16.02.02.03.04.05.05l3.3 2.21c-.01.13-.04.26-.04.4 0 2.88 2.34 5.22 5.22 5.22s5.22-2.34 5.22-5.22-2.34-5.22-5.22-5.22Zm0-12.07c1.77 0 3.22 1.44 3.22 3.22s-1.44 3.22-3.22 3.22S13.76 7 13.76 5.22 15.2 2 16.98 2ZM5.22 15.78C3.45 15.78 2 14.34 2 12.56s1.44-3.22 3.22-3.22 3.22 1.44 3.22 3.22S7 15.78 5.22 15.78Zm11.77 6.72c-1.77 0-3.22-1.44-3.22-3.22s1.44-3.22 3.22-3.22 3.22 1.44 3.22 3.22-1.44 3.22-3.22 3.22Z" />
    </svg>
  )
}
export default SvgMsKlimadashboardIconsNaviTeilen
